module.exports = __webpack_public_path__ + "media/logos/ideo-9def026d.png";